import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import { CartModel } from '../../../models/cart-product-model';
import { CouponModel } from '../../../models/coupon.model';
import { CartService } from '../../../services/cart.service';

@Component({
  selector: 'app-coupon',
  templateUrl: './coupon.component.html',
  styleUrl: './coupon.component.scss',
  standalone: false,
})
export class CouponComponent implements OnInit {
  @Input() coupon: CouponModel;
  @Input() amount: number;
  @Input() cartView: boolean;
  @Input() adminView: boolean;

  @Output() changeAmount = new EventEmitter<CartModel>();
  @Output() couponDeleted = new EventEmitter<CouponModel>();
  @Output() couponActiveStateChanged = new EventEmitter<boolean>();

  private timeout: any;

  constructor(private cartService: CartService) {}

  public addedToShoppingCart = false;

  public ngOnInit() {
    if (this.amount === undefined) {
      this.amount = 1;
    }
    if (this.cartService.getItems().length > 0 && this.cartView) {
      this.cartService.getItems().map(cartItem => {
        if (cartItem.product.id === this.coupon.id) {
          this.amount = cartItem.amount;
        }
      });
    }
  }

  public addToShoppingCart(coupon: CouponModel): void {
    if (this.addedToShoppingCart) {
      return;
    }
    const couponCart: CartModel = {
      product: coupon,
      amount: this.amount,
    };
    this.cartService.addToCart(couponCart);
    this.addedToShoppingCart = true;

    this.timeout = setTimeout(() => {
      this.addedToShoppingCart = false;
    }, 1000);
    return;
  }

  public amountPlus(): void {
    this.amount++;
    const cartModel: CartModel = {
      product: this.coupon,
      amount: this.amount,
    };
    this.changeAmount.emit(cartModel);
  }

  public amountMinus(): void {
    if (this.amount > 1) {
      this.amount--;
      const cartModel: CartModel = {
        product: this.coupon,
        amount: this.amount,
      };
      this.changeAmount.emit(cartModel);
    }
  }

  public onCouponActiveStateChanged(event: ToggleSwitchChangeEvent): void {
    this.coupon.isActive = event.checked;
    this.couponActiveStateChanged.emit(event.checked);
  }

  public onDeleteCoupon(): void {
    this.couponDeleted.emit(this.coupon);
  }
}
